(() => {
  const APPROVED = {
    serum: {
      one_time: { 1: [4900, 7800, 37, 2900], 3: [4500, 7800, 42, 3300] },
      subscription: { 1: [4200, 7800, 46, 3600], 3: [3800, 7800, 51, 4000] }
    },
    mist: {
      one_time: { 1: [4500, 7100, 37, 2600], 3: [4100, 7100, 42, 3000] },
      subscription: { 1: [3900, 7100, 45, 3200], 3: [3500, 7100, 51, 3600] }
    }
  };

  if (customElements.get('lt-purchase-picker')) return;

  customElements.define('lt-purchase-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      document.documentElement.classList.add('lt-skincare-product');
      this.mountInProductInfo();
      this.alignFaq();
      this.promoteGreenTeaIngredient();
      this.type = 'one_time';
      this.bottles = 3;
      this.currency = this.dataset.currency || 'USD';
      this.prices = APPROVED[this.dataset.productKey];
      this.product = this.readProduct();
      this.baseVariant = this.findBaseVariant();
      this.addEventListener('click', this.onClick);
      this.render();
    }

    mountInProductInfo() {
      const blockList = document.querySelector('safe-sticky.product-info .product-info__block-list');
      if (!blockList) return;
      const firstLegacyPurchaseBlock = blockList.querySelector('[data-block-type="variant-picker"]');
      blockList.querySelectorAll('[data-block-type="price"], [data-block-type="payment-terms"], [data-block-type="variant-picker"], [data-block-type="quantity-selector"], [data-block-type="buy-buttons"]').forEach((block) => {
        block.hidden = true;
        block.setAttribute('aria-hidden', 'true');
      });
      blockList.insertBefore(this, firstLegacyPurchaseBlock || null);
    }

    alignFaq() {
      const faq = document.querySelector('[id^="lt-faq-"]');
      if (!faq || faq.dataset.ltAligned === 'true') return;
      faq.dataset.ltAligned = 'true';
      faq.classList.add('lt-picker-adjacent-faq');
      Object.assign(faq.style, {
        width: '100%',
        maxWidth: 'none',
        margin: '0',
        padding: '16px 0 0',
        background: 'transparent'
      });
      const inner = faq.querySelector('.lt-faq__inner');
      if (inner) Object.assign(inner.style, { width: '100%', maxWidth: 'none', margin: '0' });
      this.insertAdjacentElement('afterend', faq);
    }

    promoteGreenTeaIngredient() {
      const list = document.querySelector('[id^="lt-ingredients-"] .lt-ingredients__list');
      if (!list || list.dataset.ltGreenTeaFirst === 'true') return;
      const greenTeaCard = Array.from(list.children).find((card) => {
        const label = ((card.querySelector('img')?.alt || '') + ' ' + (card.textContent || '')).toLowerCase();
        return label.includes('green tea') || label.includes('绿茶');
      });
      if (!greenTeaCard) return;
      list.prepend(greenTeaCard);
      list.dataset.ltGreenTeaFirst = 'true';
    }

    disconnectedCallback() { this.removeEventListener('click', this.onClick); }

    readProduct() {
      try {
        return JSON.parse(this.querySelector('[data-lt-product]')?.textContent || '{}');
      } catch (error) {
        console.error('Lovetenet purchase picker product data error', error);
        return {};
      }
    }

    findBaseVariant() {
      const variants = this.product?.variants || [];
      return variants.find((variant) => {
        const label = [variant.title, ...(variant.options || [])].join(' ').toLowerCase();
        return label.includes('one-time purchase') || label.includes('one time purchase');
      }) || variants.find((variant) => variant.available) || variants[0];
    }

    findSellingPlan() {
      const targetPrice = this.prices.subscription[this.bottles][0];
      const allocations = this.baseVariant?.selling_plan_allocations || [];
      const allocation = allocations.find((item) => Number(item.price) === targetPrice);
      return allocation?.selling_plan_id || allocation?.selling_plan?.id || null;
    }

    onClick = async (event) => {
      const type = event.target.closest('[data-lt-type]');
      const card = event.target.closest('[data-lt-bottles]');
      const cart = event.target.closest('[data-lt-cart]');
      const buy = event.target.closest('[data-lt-buy]');
      if (type) this.type = type.dataset.ltType;
      if (card) this.bottles = Number(card.dataset.ltBottles);
      if (type || card) this.render();
      if (cart || buy) await this.submit(Boolean(buy));
    };

    setStatus(message, isError = false) {
      const status = this.querySelector('[data-lt-status]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', isError);
      status.hidden = !isError;
    }

    setBusy(busy) {
      this.querySelectorAll('[data-lt-cart], [data-lt-buy]').forEach((button) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', String(busy));
      });
    }

    async submit(buyNow) {
      const sellingPlan = this.type === 'subscription' ? this.findSellingPlan() : null;
      if (!this.baseVariant?.id) {
        this.setStatus('This product is not available right now.', true);
        return;
      }
      if (this.type === 'subscription' && !sellingPlan) {
        this.setStatus('The selected subscription plan is not available. Please refresh and try again.', true);
        return;
      }

      const item = { id: this.baseVariant.id, quantity: this.bottles };
      if (sellingPlan) item.selling_plan = sellingPlan;

      this.setBusy(true);
      this.setStatus('Adding your selection…');
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Unable to add this item.');
        }

        let destination = buyNow ? '/checkout' : '/cart';
        if (this.type === 'one_time' && this.bottles === 3) {
          destination = '/discount/LT-SKINCARE-3?redirect=' + encodeURIComponent(destination);
        }
        window.location.assign(destination);
      } catch (error) {
        this.setStatus(error.message || 'Unable to add this item. Please try again.', true);
        this.setBusy(false);
      }
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.currency, maximumFractionDigits: 0
      }).format(cents / 100);
    }

    render() {
      const row = this.prices[this.type][this.bottles];
      const [unit, compare, percent, saved] = row;
      this.querySelectorAll('[data-lt-type]').forEach((el) => {
        const active = el.dataset.ltType === this.type;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', String(active));
      });
      this.querySelectorAll('[data-lt-bottles]').forEach((el) => {
        const active = Number(el.dataset.ltBottles) === this.bottles;
        const values = this.prices[this.type][Number(el.dataset.ltBottles)];
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-checked', String(active));
        el.querySelector('[data-lt-unit]').textContent = this.money(values[0]) + ' / bottle';
        el.querySelector('[data-lt-compare-unit]').textContent = this.money(values[1]) + ' / bottle';
        el.querySelector('[data-lt-save]').textContent = 'Save ' + values[2] + '%';
        el.querySelector('[data-lt-save-money]').textContent = 'Save ' + this.money(values[3]) + ' per bottle';
      });
      const delivery = this.querySelector('[data-lt-delivery]');
      delivery.hidden = this.type !== 'subscription';
      delivery.textContent = this.bottles === 3
        ? 'Billed and shipped every 3 months. 3 bottles per delivery.'
        : 'Billed and shipped every month. 1 bottle per delivery.';
      this.querySelector('[data-lt-total]').textContent = this.money(unit * this.bottles);
      this.querySelector('[data-lt-compare-total]').textContent = this.money(compare * this.bottles);
      const total = this.money(unit * this.bottles);
      this.querySelector('[data-lt-cart]').textContent = 'Add to cart · ' + total;
      this.querySelector('[data-lt-buy]').textContent = 'Buy it now · ' + total;
      const sellingPlanReady = this.type !== 'subscription' || Boolean(this.findSellingPlan());
      this.querySelectorAll('[data-lt-cart], [data-lt-buy]').forEach((button) => {
        button.disabled = !this.baseVariant?.id || !sellingPlanReady;
      });
      this.setStatus(
        sellingPlanReady ? '' : 'The selected subscription plan is not available. Please refresh and try again.',
        !sellingPlanReady
      );
    }
  });
})();
